/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProjectFinancialClaimsDetailsIdDelete } from '../fn/project-financial-claims-details/api-project-financial-claims-details-id-delete';
import { ApiProjectFinancialClaimsDetailsIdDelete$Params } from '../fn/project-financial-claims-details/api-project-financial-claims-details-id-delete';
import { apiProjectFinancialClaimsDetailsIdDelete$Plain } from '../fn/project-financial-claims-details/api-project-financial-claims-details-id-delete-plain';
import { ApiProjectFinancialClaimsDetailsIdDelete$Plain$Params } from '../fn/project-financial-claims-details/api-project-financial-claims-details-id-delete-plain';
import { apiProjectFinancialClaimsDetailsPost } from '../fn/project-financial-claims-details/api-project-financial-claims-details-post';
import { ApiProjectFinancialClaimsDetailsPost$Params } from '../fn/project-financial-claims-details/api-project-financial-claims-details-post';
import { apiProjectFinancialClaimsDetailsPost$Plain } from '../fn/project-financial-claims-details/api-project-financial-claims-details-post-plain';
import { ApiProjectFinancialClaimsDetailsPost$Plain$Params } from '../fn/project-financial-claims-details/api-project-financial-claims-details-post-plain';
import { apiProjectFinancialClaimsDetailsPut } from '../fn/project-financial-claims-details/api-project-financial-claims-details-put';
import { ApiProjectFinancialClaimsDetailsPut$Params } from '../fn/project-financial-claims-details/api-project-financial-claims-details-put';
import { apiProjectFinancialClaimsDetailsPut$Plain } from '../fn/project-financial-claims-details/api-project-financial-claims-details-put-plain';
import { ApiProjectFinancialClaimsDetailsPut$Plain$Params } from '../fn/project-financial-claims-details/api-project-financial-claims-details-put-plain';
import { CreateProjectFinancialClaimsDetailsCommandResult } from '../models/create-project-financial-claims-details-command-result';
import { DeleteProjectFinancialClaimsDetailsCommandResult } from '../models/delete-project-financial-claims-details-command-result';
import { UpdateProjectFinancialClaimsDetailsCommandResult } from '../models/update-project-financial-claims-details-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectFinancialClaimsDetailsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectFinancialClaimsDetailsPut()` */
  static readonly ApiProjectFinancialClaimsDetailsPutPath = '/api/ProjectFinancialClaimsDetails';

  /**
   * Updates an existing Project Financial Claim Detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialClaimsDetailsPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialClaimsDetailsPut$Plain$Response(params?: ApiProjectFinancialClaimsDetailsPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectFinancialClaimsDetailsCommandResult>> {
    return apiProjectFinancialClaimsDetailsPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Project Financial Claim Detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialClaimsDetailsPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialClaimsDetailsPut$Plain(params?: ApiProjectFinancialClaimsDetailsPut$Plain$Params, context?: HttpContext): Observable<UpdateProjectFinancialClaimsDetailsCommandResult> {
    return this.apiProjectFinancialClaimsDetailsPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectFinancialClaimsDetailsCommandResult>): UpdateProjectFinancialClaimsDetailsCommandResult => r.body)
    );
  }

  /**
   * Updates an existing Project Financial Claim Detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialClaimsDetailsPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialClaimsDetailsPut$Response(params?: ApiProjectFinancialClaimsDetailsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectFinancialClaimsDetailsCommandResult>> {
    return apiProjectFinancialClaimsDetailsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing Project Financial Claim Detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialClaimsDetailsPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialClaimsDetailsPut(params?: ApiProjectFinancialClaimsDetailsPut$Params, context?: HttpContext): Observable<UpdateProjectFinancialClaimsDetailsCommandResult> {
    return this.apiProjectFinancialClaimsDetailsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateProjectFinancialClaimsDetailsCommandResult>): UpdateProjectFinancialClaimsDetailsCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectFinancialClaimsDetailsPost()` */
  static readonly ApiProjectFinancialClaimsDetailsPostPath = '/api/ProjectFinancialClaimsDetails';

  /**
   * Creates a new Project Financial Claim Detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialClaimsDetailsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialClaimsDetailsPost$Plain$Response(params?: ApiProjectFinancialClaimsDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectFinancialClaimsDetailsCommandResult>> {
    return apiProjectFinancialClaimsDetailsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Project Financial Claim Detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialClaimsDetailsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialClaimsDetailsPost$Plain(params?: ApiProjectFinancialClaimsDetailsPost$Plain$Params, context?: HttpContext): Observable<CreateProjectFinancialClaimsDetailsCommandResult> {
    return this.apiProjectFinancialClaimsDetailsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectFinancialClaimsDetailsCommandResult>): CreateProjectFinancialClaimsDetailsCommandResult => r.body)
    );
  }

  /**
   * Creates a new Project Financial Claim Detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialClaimsDetailsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialClaimsDetailsPost$Response(params?: ApiProjectFinancialClaimsDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectFinancialClaimsDetailsCommandResult>> {
    return apiProjectFinancialClaimsDetailsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new Project Financial Claim Detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialClaimsDetailsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectFinancialClaimsDetailsPost(params?: ApiProjectFinancialClaimsDetailsPost$Params, context?: HttpContext): Observable<CreateProjectFinancialClaimsDetailsCommandResult> {
    return this.apiProjectFinancialClaimsDetailsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateProjectFinancialClaimsDetailsCommandResult>): CreateProjectFinancialClaimsDetailsCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectFinancialClaimsDetailsIdDelete()` */
  static readonly ApiProjectFinancialClaimsDetailsIdDeletePath = '/api/ProjectFinancialClaimsDetails/{id}';

  /**
   * Deletes a Project Financial Claim Detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialClaimsDetailsIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectFinancialClaimsDetailsIdDelete$Plain$Response(params: ApiProjectFinancialClaimsDetailsIdDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectFinancialClaimsDetailsCommandResult>> {
    return apiProjectFinancialClaimsDetailsIdDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a Project Financial Claim Detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialClaimsDetailsIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectFinancialClaimsDetailsIdDelete$Plain(params: ApiProjectFinancialClaimsDetailsIdDelete$Plain$Params, context?: HttpContext): Observable<DeleteProjectFinancialClaimsDetailsCommandResult> {
    return this.apiProjectFinancialClaimsDetailsIdDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectFinancialClaimsDetailsCommandResult>): DeleteProjectFinancialClaimsDetailsCommandResult => r.body)
    );
  }

  /**
   * Deletes a Project Financial Claim Detail.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectFinancialClaimsDetailsIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectFinancialClaimsDetailsIdDelete$Response(params: ApiProjectFinancialClaimsDetailsIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectFinancialClaimsDetailsCommandResult>> {
    return apiProjectFinancialClaimsDetailsIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a Project Financial Claim Detail.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectFinancialClaimsDetailsIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectFinancialClaimsDetailsIdDelete(params: ApiProjectFinancialClaimsDetailsIdDelete$Params, context?: HttpContext): Observable<DeleteProjectFinancialClaimsDetailsCommandResult> {
    return this.apiProjectFinancialClaimsDetailsIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteProjectFinancialClaimsDetailsCommandResult>): DeleteProjectFinancialClaimsDetailsCommandResult => r.body)
    );
  }

}
